import { render, staticRenderFns } from "./StudioMediaCard.vue?vue&type=template&id=472b0afa&scoped=true&"
import script from "./StudioMediaCard.vue?vue&type=script&lang=ts&"
export * from "./StudioMediaCard.vue?vue&type=script&lang=ts&"
import style0 from "./StudioMediaCard.vue?vue&type=style&index=0&id=472b0afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b0afa",
  null
  
)

export default component.exports